import React, { Fragment } from 'react';
import Container from './Container';

import './UberToronto.css';
import { Helmet } from 'react-helmet';

const UberToronto = () => (
  <Fragment>
    <Helmet>
      <title>Drive in Toronto | Autzu</title>
      <meta
        name="description"
        content="Earn on Uber without a car in Toronto."
      />
      <script type="application/ld+json">
        {`{
          "@context": "http://schema.org/",
          "@type": "JobPosting",
          "title": "Autzu Driver | Uber partner",
          "description": "<h1><b>Drive Uber without owning a car.</b></h1><p>Do you want to drive Uber, but don’t have an eligible car?</p><p>Drive Autzu premium cars at a low hourly rate. From <b> only $4.50 per hour</b>, you can drive 4, 8, or 12 hours each day whenever you choose and make money on Uber.</p><h2>Looking for an overnight driving job?</h2><ul><li> Our cars are available 24 hours a day, 365 days a year.</li></ul><br/><h3><b>Insurance:</b></h3><ul><li>All our cars are fully insured. Maintenance and even roadside assistance are already included in the price of hourly rental.</li></ul><br/><h3><b>Kilometers:</b></h3><ul><li>No limits whatsoever. All we ask is you fill up the tank before you drop off the car, and all our cars take regular 87.</li></ul><br/><h3><b>Easy to start:</b></h3><ul><li>If you’re eligible to drive for Uber, you can sign up with Autzu. No upfront payments, no deposit, no hidden fees.</li></ul><br/><h3>Why wait? Start now at <a href='https://www.autzu.com/toronto/uber'> Autzu!</a></h3><br/><h3> <b>Additional Information:</b> </h3><p> If you have previous employment experience in transportation (such as a delivery driver, driver, professional driver, driving job, truck driver, heavy and tractor-trailer driver, cdl truck driver, class a or class b driver, local truck driver, company truck driver, taxi driver, taxi chauffeur, cab driver, cab chauffeur, taxi cab driver, transit bus driver, bus driver, coach bus driver, bus operator, shuttle driver, bus chauffeur) you might also consider partnering with Uber and earn great money. We also welcome drivers who have worked with other peer-to-peer ridesharing or driving networks like Lyft, Sidecar, Deliv, Postmates, Roadie. Our driver partners come from all backgrounds and industries ranging from traditional driving and transportation industries to other industries. </p>",
          "datePosted": "2019-01-25",
          "employmentType": ["PART_TIME", "FULL_TIME"],
          "hiringOrganization": {
            "@type": "Organization",
            "url": "https://www.autzu.com",
            "name": "Autzu",
            "sameAs": [
              "https://www.facebook.com/Autzu/",
              "https://www.instagram.com/autzuhq/",
              "https://www.linkedin.com/company/autzu/"
            ],
            "logo": "https://www.autzu.com/AutzuLogoSquare.png"
          },
          "jobLocation": {
            "@type": "Place",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Toronto",
              "addressRegion": "ON",
              "postalCode": "M5V 1M5",
              "streetAddress": "621 King St W",
              "addressCountry": "CA"
            }
          },
          "baseSalary": {
            "@type": "MonetaryAmount",
            "currency": "CAD",
            "value": {
              "@type": "QuantitativeValue",
              "minValue": 15,
              "maxValue": 30,
              "unitText": "HOUR"
            }
          }
        }`}
      </script>
    </Helmet>
    <Container />
  </Fragment>
);

export default UberToronto;



// WEBPACK FOOTER //
// ./src/components/Static/UberToronto/index.js